import { useEffect, useState } from 'react';

const SETTLE_FRAMES = 2;

/**
 * Tracks whether the calendar has finished laying out after loading completes.
 *
 * Stays `false` while `isLoading` is true and for `SETTLE_FRAMES` animation frames after it
 * turns false, giving a freshly mounted calendar time to lay out and place its events.
 * Resets to `false` whenever `isLoading` becomes true again.
 *
 * @param {boolean} isLoading - Whether the scheduler data is still loading.
 * @returns {boolean} `true` once loading is done and the settle frames have elapsed.
 */
export default function useSettledAfterLoading(isLoading) {
  const [isSettled, setIsSettled] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setIsSettled(false);
      return undefined;
    }

    let frame;
    const waitFrames = (remaining) => {
      frame = window.requestAnimationFrame(() => {
        if (remaining > 1) waitFrames(remaining - 1);
        else setIsSettled(true);
      });
    };
    waitFrames(SETTLE_FRAMES);

    return () => window.cancelAnimationFrame(frame);
  }, [isLoading]);

  return isSettled;
}
